/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// Re-initialize the product-template section after HTMX swaps it in.
(function () {
  // Unload the current product-template section before HTMX swaps it out.
  // This removes the old section's event listeners so they don't leak.
  document.body.addEventListener('htmx:beforeSwap', function (event) {
    var target = event.detail.target;

    if (!target || !target.classList.contains('product-template')) return;

    var sectionId = target.getAttribute('data-section-id');
    if (!sectionId) return;

    var unloadEvent = new CustomEvent('shopify:section:unload', {
      detail: { sectionId: sectionId },
      bubbles: true
    });

    target.dispatchEvent(unloadEvent);
  });

  // Load the new product-template section after HTMX swaps it in.
  document.body.addEventListener('htmx:afterSwap', function (event) {
    var target = event.detail.target;

    if (!target || !target.classList.contains('product-template')) return;

    // The target reference may be detached after an outerHTML swap.
    var newContainer = document.querySelector('.product-template');
    if (!newContainer) return;

    if (window.theme && window.theme.sections) {
      window.theme.sections.load('product-template', newContainer);
    }
  });
})();
